/**
 * Types de la liste d'attente côté front (modèle simplifié DEC-8 : FIFO, pas de
 * statut ni d'ordonnancement). Le back renvoie une forme à plat ; on garde
 * quelques helpers d'affichage.
 */

/** Entrée de liste d'attente renvoyée par l'API. */
export interface QueueEntryApi {
  id: number;
  patientId: number;
  patientFirstName: string | null;
  patientLastName: string | null;
  currentStep: string;
  walkIn: boolean;
  appointmentTime: string | null; // "HH:mm:ss"
  arrivalTime: string | null; // ISO datetime (clé FIFO)
  waitingMinutes: number | null;
  assignedDoctorId: number | null;
  assignedDoctorName: string | null;
}

/** RDV du jour (flag page Patients). */
export interface TodayAppointmentApi {
  patientId: number;
  patientFirstName: string | null;
  patientLastName: string | null;
  appointmentTime: string | null; // "HH:mm:ss"
  doctorId: number | null;
  doctorName: string | null;
}

/** "HH:mm:ss" ou ISO datetime → "HH:MM". */
export const hm = (value?: string | null): string | null => {
  if (!value) return null;
  const timePart = value.includes("T") ? value.split("T")[1] : value;
  return timePart ? timePart.slice(0, 5) : null;
};

/** Initiales à partir du prénom/nom. */
export const initials = (first?: string | null, last?: string | null): string => {
  const a = (first || "").trim().charAt(0).toUpperCase();
  const b = (last || "").trim().charAt(0).toUpperCase();
  return a + b || "?";
};
